import { FC, useState, useMemo } from 'react';
import './style.scss';
import { Button, message, Modal } from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    ArrowDownOutlined
} from '@ant-design/icons';
import { PATH, HOST_NAME } from '../../api';

const Pre: FC<any> = ({ next = () => {}, nextParam }) => {
    const tableData: any = [
        {
            fileName: '医疗广告审查申请表',
            type: 'applyFiles'
        },
        {
            fileName: '医疗广告成品样件表',
            type: 'sampleFiles'
        }
    ];
    const columns = [
        {
            title: '序号',
            width: '5%',
            filed: 'index'
        },
        {
            title: '材料名称',
            width: '30%',
            filed: 'fileName'
        },
        {
            title: '操作',
            width: '15%',
            filed: 'bz'
        }
    ];

    const isSuccess = useMemo(() => !nextParam?.materialResult?.data?.length, [nextParam]);
    const [openModal, setOpenModal] = useState(false);

    async function applyClick() {
        window.location.href =
            'http://zxbl.sczwfw.gov.cn/app/presonServices/netApply/4357962816214040576/0?areaCode=510000000000';
    }

    function okClick() {
        setOpenModal(false);
        // applyClick();
        next(5);
    }

    async function downLoad(type: string) {
        const [{ downloadName, fileName }] = nextParam?.materialResult[type];
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = `${HOST_NAME}${PATH.DOWN_LOAD_PATH}?downloadName=${downloadName}&fileName=${fileName}`;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
    }

    return (
        <div className='box pre-box'>
            <div className='text-title'>
                <span className='line'></span>
                <span>智能预审</span>
            </div>
            <div className='text-title-line'></div>
            {isSuccess ? null : (
                <div style={{ padding: '15px 30px' }}>
                    {nextParam?.materialResult.data.map((lable: string, index: number) => (
                        <div
                            style={{ lineHeight: '35px', fontSize: 16, textAlign: 'left' }}
                            key={index}
                        >
                            {index + 1}、{lable}
                        </div>
                    ))}
                    <div
                        className='success-text'
                        style={{ padding: 10, color: 'red', fontSize: 22 }}
                    >
                        <CloseCircleOutlined />
                        智能预审未通过，建议返回”上一步“修改错误申请信息后，再提交申请。若再次核对确认无误，可继续提交。
                    </div>
                </div>
            )}
            {isSuccess ? (
                <div>
                    <div className='success-text'>
                        <CheckCircleOutlined /> 智能预审通过
                    </div>
                </div>
            ) : null}
            <div>
                <div className='tips-text'>
                    请下载《医疗广告审查申请表》、《医疗广告成品样件表》，打印盖章后，可直接用于材料审核。
                </div>
                <table className='table table-responsive' align='center'>
                    <tbody>
                        <tr>
                            {columns.map(({ title, width, filed }) => (
                                <td className='bl-bg text-tag' width={width} key={filed}>
                                    {title}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                    <tbody className='text-tag'>
                        {tableData.map(({ fileName, type }: any, index: number) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{fileName}</td>
                                <td>
                                    <span className='btn' onClick={downLoad.bind(null, type)}>
                                        <ArrowDownOutlined />
                                        <span style={{ marginLeft: '2px' }}>下载</span>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <Button
                    onClick={next.bind(null, 3)}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35, marginRight: 15 }}
                >
                    上一步
                </Button>
                <Button
                    onClick={() => setOpenModal(true)}
                    type='primary'
                    style={{
                        width: 140,
                        marginTop: 15,
                        height: 35
                    }}
                >
                    下一步
                </Button>
            </div>

            <Modal
                title={
                    <div>
                        <span style={{ color: ' #faad14', fontSize: '20px', marginRight: '15px' }}>
                            <ExclamationCircleOutlined />
                        </span>
                        温馨提示
                    </div>
                }
                open={openModal}
                footer={[
                    <Button type='default' onClick={() => setOpenModal(false)}>
                        否
                    </Button>,
                    <Button type='primary' onClick={okClick}>
                        是
                    </Button>
                ]}
                onCancel={() => setOpenModal(false)}
                destroyOnClose={true}
                width={550}
                style={{ top: '30%' }}
            >
                <span style={{ fontSize: '18px' }}>是否已经下载附件</span>
            </Modal>
        </div>
    );
};

export default Pre;
